import { Component, OnDestroy, OnInit } from '@angular/core';

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: string }>;
}
import { Router } from '@angular/router';

import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { UiService } from '@s-services/ui.service';
import { AuthService } from '@s-services/auth.service';
import { CompanyService } from '@s-services/company.service';
import { CompanyProgressService } from '@s-services/company-progress.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  onlineOffline: boolean = navigator.onLine;
  deferredPrompt: BeforeInstallPromptEvent | null = null;

  constructor(
    public router: Router,
    public authService: AuthService,
    public companyService: CompanyService,
    public uiService: UiService,
    public companyProgress: CompanyProgressService,
  ) {

    window.addEventListener('online', () => { this.onlineOffline = true; });
    window.addEventListener('offline', () => {
      this.uiService.showSimpleSnackbarAlert('Keine Internetverbindung!', 'ok');
    });

    window.addEventListener('beforeinstallprompt', (e: Event) => {
      e.preventDefault();
      this.deferredPrompt = e as BeforeInstallPromptEvent;
    });
  }

  ngOnInit() {
    combineLatest([this.authService.user, this.companyService.company, this.companyService.companyBilling])
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {});
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onInstallApp() {
    this.deferredPrompt!.prompt();
    this.deferredPrompt!.userChoice.then((choiceResult: { outcome: string }) => {
      this.deferredPrompt = null;
    });
  }
}
